import React from "react";
import {ListItem, SectionHeading} from "../PromotionsText";

const PromotionCommunicationsSection = () => (
  <>
    <SectionHeading>Promotion Communications</SectionHeading>

    <ListItem marker="(a)">
      {"Unless otherwise indicated in the applicable Promotion Communication, participation in each Promotion is open to players from any the Platforms but is limited to one per person, family, household, address or organization to whom We send the Promotion Communication. We reserve the right to restrict participation in certain Promotions to players who fulfill specific selection criteria. Where a Promotion Communication permits multiple participants, We reserve the right, in Our sole discretion, to limit the number of participants."}
    </ListItem>

    <ListItem marker="(b)" withBottomMargin>
      {"Unless otherwise indicated in the Promotion Communication, it is intended for the addressed recipient or category of recipient only and cannot be transferred. If You are not the intended recipient or within the intended category of recipient, then the offer is null and void."}
    </ListItem>
  </>
);

export default PromotionCommunicationsSection;
